<template>
    <div id="message_list">
        <div class="message_list">
            <div class="message_list1">
                <div class="message_list2 flex-row">
                    <span>热门题材推荐</span>
                    <!-- <p>

                    </p> -->
                </div>
                <div class="flex" style="width: 100%;">
                    <div style="flex-shrink: 0;width: 80px;">
                        读者:
                    </div>
                    <div style="width: 80%;">
                        <TabSwitcher :value="titleIndex" :tabs="list" @change="titleSelect" />
                    </div>
                </div>
                <div class="flex t-m-t-17" style="width: 100%;">
                    <div style="flex-shrink: 0;width: 80px;">
                        分类:
                    </div>
                    <div class="flex" style="width: 80%;flex-wrap: wrap;">
                        <p class="typeItem" :class="{ active: Object.keys(curTypesObj).length === 0 }"
                            @click="selectTypesClick(-1, '')">全部</p>
                        <p class="typeItem"
                            :class="{ active: Object.keys(curTypesObj).length > 0 && curTypesObj.id === item.id }"
                            v-for="(item, index) in types" :key="index" @click="selectTypesClick(index, item)">
                            {{ item.category }}
                        </p>
                    </div>
                </div>
                <div class="hot-text" v-if="Object.keys(curTypesObj).length > 0">
                    <span v-if="getUserTypeImg(mixinUserInfo).name === '普通会员'">{{ curTypesObj.preview }}</span>
                    <p v-else :class="show ? 'showClass' : 'hideClass'">{{ curTypesObj.content }}</p>
                    <a v-if="getUserTypeImg(mixinUserInfo).name === '普通会员'" class="vipLook cursor_1"
                        @click.stop="vipLook" type="primary" underline>vip查看全部</a>
                    <a v-else class="vipMore cursor_1" @click.stop="vipLook" type="primary"
                        @click="show = !show">{{ show ? '收缩' : '展开' }}<i :class="!show?'el-icon-arrow-down':'el-icon-arrow-up'"></i></a>
                </div>
            </div>
            <div class="message_list7" v-if="!isNotEmpty">
                <noData></noData>
            </div>
            <div class="message_list7" ref="scrollContainer" v-else>
                <div class="classroom-list t-m-t-20">
                    <div class="classroom-list__item" v-for="(item, i) in curList" :key="i"
                        @click.stop="toDetail(item)">
                        <div class="cover">
                            <img :src="item.cover" />
                        </div>

                        <div class="classroom-list__doc">
                            <p class="t-font-18 t-bold u-line-2" style="color: #111111;">{{ item.title }}</p>
                            <p class="t-font-14 flex-row" style="color: #333333;margin-top: 5px;"><img
                                    :src="`https://api.esrke.com/icon/platform/${item.platform}.png`" width="20"
                                    height="20" /><span class="t-m-l-10">作者：{{ item.author }}</span></p>
                            <p class="flex-row t-font-14" style="color: #333333;margin-top: 5px;">{{
                                item.status ? '已完结' : '连载中' }} {{ item.chapters }}章 {{
                                    $validata.formatNumberToUnit(item.words, 1) }}字</p>
                            <div class="t-font-14 flex-row flex-row-between t-p-r-10"
                                style="color: #333333;margin-top: 5px;">
                                <p>阅读量：{{ $validata.formatNumberToUnit(item.reads, 1) }}</p>
                                <p class="t-font-14 flex-row cursor_1" style="margin-left: 30px;font-weight: 400;"
                                    @click.stop="collectClick(item)">
                                    <img class="t-m-r-5" width="17" height="14"
                                        :src="item?.collect ? collectIcon[0] : collectIcon[1]" alt="" />
                                    <span :class="item?.collect ? 'sc' : ''">{{ item?.collect ? '已收藏' : '收藏' }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref="loader" class="loader">
                    <div v-if="loading">加载中...</div>
                    <!-- <div v-if="!hasMore">没有更多数据了</div> -->
                </div>
            </div>
        </div>
        <!-- 参考格式弹框 -->
        <tipPopup ref="tipPopup"></tipPopup>
    </div>
</template>
<script>
import HApi from '@/api/hottc.js';
import data from '@/assets/data'
import { EventBus } from '@/utils/eventBus'
import noData from '@/components/no_data.vue';
import TabSwitcher from '@/components/contactUs/TabSwitcher.vue'
import tipPopup from '@/components/classroom/tip_popup.vue'
import { scrollerMixin } from '@/mixin/scrollerMixin';
export default {
    mixins: [scrollerMixin],
    components: {
        noData, TabSwitcher, tipPopup
    },
    data() {
        return {
            collectIcon: data.collectIcon,//收藏图标
            titleIndex: 0,
            list: [{ name: '女频', level: '1' }, { name: '男频', level: '0' }],//读者
            types: [],//分类
            level: '',//初始化级别
            curTypesObj: {},//选中的分类对象信息
            curList: [],//当前选中的数组
            pageNum: 1,
            pageSize: 16,
            typeList: [],
            show: false
        }
    },
    created() {
        this.getUserLoginState(true)
        this.levelsList()
    },
    watch: {
        // 监听 list 变化，数据加载完成后初始化观察器
        curList: {
            handler() {
                this.$nextTick().then(() => {
                    this.initObserver({
                        scrollRequest: () => {
                            this.getList()
                        }
                    })
                })
            },
            immediate: true
        }
    },
    methods: {
        //分类
        levelsList() {
            const target = this.list[this.titleIndex].level
            HApi.categoryList(target).then(res => {
                if (res.code === 200) {
                    this.types = res.data
                    // if (this.types.length > 0) {
                    //     this.getList()
                    // }
                }
            })
        },
        //获取分类列表
        async getList() {
            this.loading = true;
            try {
                const target = this.list[this.titleIndex].level

                // const categoryId = Object.keys(this.curTypesObj).length ? this.curTypesObj.id : ''
                const response = await HApi.subjectList({ pageNum: this.pageNum, pageSize: this.pageSize, target: Number(target), categoryId: this.curTypesObj?.id })
                if (response.code === 200) {
                    this.curList = [...this.curList, ...response.data];
                    this.pageNum++;
                    this.hasMore = response.data.length >= this.pageSize;
                    this.isNotEmpty = this.curList.length > 0 ? true : false
                } else {
                    this.$message.warning(response.msg)
                }

            } catch (error) {
                console.error('滚动分页出现问题:', error);
            } finally {
                this.loading = false;
            }
        },
        //选中
        titleSelect(index) {
            if (this.titleIndex === index) return
            this.pageNum = 1
            this.curTypesObj = {}
            this.titleIndex = index
            this.levelsList()
            this.curList = []
            this.getList()
        },
        selectTypesClick(index, item) {
            if (index == -1) {
                this.pageNum = 1
                this.curTypesObj = {}
                this.curList = []
                this.getList()
                return
            }
            if (this.curTypesObj?.id === item.id) return
            this.pageNum = 1
            this.curTypesObj = item
            this.curList = []
            this.getList()
        },
        toDetail(item) {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            if (!item.display) {
                this.$message.warning('当前作品已经关闭')
                return
            }
            this.$router.push({ path: '/hottc_detail', query: { uid: item.uid } })
        },
        toBuyHistory() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$router.push({ path: '/hottc_history' })
        },
        vipLook() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            if (this.getUserTypeImg(this.mixinUserInfo).name === '普通会员') {
                EventBus.$emit('openVip')
                return
            }
        },
        collectClick(item) {
            //取消收藏
            if (item.collect) {
                HApi.closeCollect(item.uid).then(res => {
                    if (res.code == 200) {
                        this.$message.success('取消收藏成功！')
                        item.collect = false
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } else {
                //收藏
                HApi.openCollect(item.uid).then(res => {
                    if (res.code == 200) {
                        item.collect = true
                        this.$message.success('收藏成功！')
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
p {
    padding: 0;
    margin: 0;
}

#message_list {
    flex: 1;
    width: 60%;
    overflow: auto;
}

.message_list {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
}

.message_list1 {
    padding: 20px;
    position: relative;
    border-bottom: 1px solid #E6EBF0;
    display: flex;
    flex-direction: column;
}

.message_list2 {
    font-weight: bold;
    font-size: 18px;
    color: #0B0B0B;
    margin-bottom: 15px;
}

.hot-text {
    position: relative;
    margin-top: 14px;
    margin-left: 80px;
    padding: 20px;
    background-color: #F8F8F8;
    color: #000000;
    border-radius: 8px;
    line-height: 1.6;
}

.showClass {
    height: auto;
}

.hideClass {
    height: 55px;
    overflow: hidden;
}

.vipLook {
    // position: absolute;
    // bottom: 10px;
    // right: 20px;
    margin-left: 0.8rem;
    color: var(--tech-primary);
    text-decoration: underline
}
.vipMore {
    position: absolute;
    bottom: 0px;
    right: 10px;
    color: var(--tech-primary);
}
.message_list7 {
    width: 100%;
    padding: 0 20px;
    flex: 1;
    overflow: auto;
    box-sizing: border-box;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover()
    }
}

.classroom-list {
    display: grid;
    gap: 18px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 100%;
    box-sizing: border-box;
}

.fenleiList {}

.classroom-list__item {
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    // border: 1px solid rgba(17, 25, 37, .15);
    cursor: pointer;
    display: flex;

    &:hover {
        box-shadow: 0 4px 12px #0000001f;

        .cover {
            img {
                transform: scale(1.1);
            }
        }
    }

    .cover {
        overflow: hidden;
        width: 100px;
        height: 133px;
        flex-shrink: 0;
        border-radius: 4px;

        img {
            transition: all 0.2s linear;

            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
}

.classroom-list__doc {
    width: 100%;
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: 0.75rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.typeItem {
    position: relative;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    margin-right: 8px;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 16px;
    color: #666666;
    transition: all 0.3s ease;
    flex-shrink: 0;
    border-radius: 6px;
    background: #F8F8F8;

    &.active {
        color: var(--tech-primary);
        background: var(--tech-btn-Lightblue);
    }

    &:hover {
        color: var(--tech-primary);
    }
}

.loader {
    font-size: 16px !important;
    grid-column: 1 / -1;
    /* 让加载器占满整行 */
    text-align: center;
    padding: 20px;
}

.sc {
    color: var(--tech-primary);
}
</style>